import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogIn } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check if admin login
    const isAdminLogin = formData.email === 'administrator' || formData.email === 'administrator@canecorsoturkey.org';
    
    try {
      const response = await axios.post(
        `${API}/auth/login`,
        new URLSearchParams({
          username: isAdminLogin ? 'administrator@canecorsoturkey.org' : formData.email,
          password: formData.password
        }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      
      if (response.data.access_token) {
        // Store token and user info
        localStorage.setItem('token', response.data.access_token);
        
        if (isAdminLogin) {
          localStorage.setItem('isAdmin', 'true');
          localStorage.setItem('mockUser', JSON.stringify({
            email: 'administrator@canecorsoturkey.org',
            name: 'Admin Yönetici'
          }));
        }
        
        toast.success('Giriş başarılı!');
        navigate('/portal/profile');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error(t('portal.login.errorMessage'));
      setFormData({ ...formData, password: '' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_f40446d8-d7d2-4086-ac19-be3f085557d2/artifacts/2lbvgq55_Cane%20Corso%20Logo-05.png"
            alt="Cane Corso Logo"
            className="h-24 w-24 mx-auto mb-4 object-contain"
          />
          <h1 className="text-3xl font-bold text-gray-900">{t('portal.login.title')}</h1>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('portal.login.username')}
              </label>
              <Input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder="ornek@email.com"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('portal.login.password')}
              </label>
              <Input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                placeholder="••••••••"
                required
              />
            </div>

            <div className="bg-gray-100 p-4 rounded-md">
              <p className="text-sm text-gray-600">
                🔒 reCAPTCHA doğrulaması (Mock)
              </p>
            </div>

            <Button type="submit" className="w-full bg-red-600 hover:bg-red-700">
              <LogIn size={18} className="mr-2" />
              {t('portal.login.loginButton')}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-gray-600">
              {t('portal.login.noAccount')}{' '}
              <Link to="/portal/register" className="text-red-600 hover:text-red-700 font-medium">
                {t('portal.login.register')}
              </Link>
            </p>
          </div>

          <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-md">
            <p className="text-sm text-blue-800 font-medium">Demo / Yönetici Bilgileri:</p>
            <p className="text-sm text-blue-700"><strong>Test Üye:</strong> test@example.com / test123</p>
            <p className="text-sm text-blue-700"><strong>Yönetici:</strong> administrator / CCTurkey35.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
